import {RestService} from './rest.service';
import {
  HomeMarketBonus,
  HomeMarketBonusListShipTosTO,
  HomeMarketBonusPagingQuery,
  HomeMarketBonusQuery,
  HomeMarketBonusTO,
  mapTOToHomeMarketBonus
} from '../../interfaces/home-market-bonus.interface';
import {inject, Injectable} from '@angular/core';
import {firstValueFrom, Observable, of} from 'rxjs';
import {catchError, map, startWith} from 'rxjs/operators';

const FETCH_COUNT = 9999999;

@Injectable({ providedIn: 'root' })
export class HomeMarketBonusRestService {

  private restService = inject(RestService);

  downloadHomeMarketBonuses$(query: HomeMarketBonusQuery): Observable<Blob> {
    return this.restService.getBlobData(`/HomeMarketBonus/asDocument`, query);
  }

  async getHomeMarketBonuses$(query: HomeMarketBonusQuery): Promise<HomeMarketBonus[]> {
    const remoteQuery: HomeMarketBonusPagingQuery = {
      pageNumber: 0, pageSize: FETCH_COUNT, sortKey: "activeFrom", sortOrder: 'ASC',
      ...query
    };
    return await firstValueFrom(this.restService.post<HomeMarketBonusTO[]>(`/HomeMarketBonus`, remoteQuery).pipe(
      map(listTO => listTO.map(mapTOToHomeMarketBonus))
    ));
  }

  getHomeMarketBonusShipTos$(): Observable<HomeMarketBonusListShipTosTO> {
    return this.restService.get<HomeMarketBonusListShipTosTO>(`/HomeMarketBonus/shipTos`).pipe(
      startWith({ loading: true, failed: false, senderShipTos: undefined, receiverShipTos: undefined }),
      map(result => ({...result, loading: !result.senderShipTos || !result.receiverShipTos, failed: false})),
      catchError(() => {
        return of({ failed: true, loading: false })
      })
    );
  }
}
